import { lazy } from 'react'
import { Route, Switch } from '@hfs/react-router'
import { getRoute } from '@hfs/website/utils/getRoute'

export const PrivacyPolicyRoutes = () => (
  <Switch>
    <Route
      component={lazy(async () => {
        const { PrivacyPolicy } = await import(
          /* webpackPrefetch: true, webpackChunkName: "News" */ '@hfs/website/react/pages/public/PrivacyPolicy'
        )

        return {
          default: PrivacyPolicy,
        }
      })}
      exact
      path={getRoute('/privacy-policy')}
    />
  </Switch>
)
